module.exports = __webpack_public_path__ + "media/stylesheets/images/Shotaro Ichikawa-138c5d54f8fd839d171480316519e8da.jpg";